export const gitCommit = 'dae168af'
